<template>
    <div id="EcommerceEnterpriseRatio" :style="{ height: '100%' }"></div>
</template>
<script>
import { lsdRegionEcommerceStatIndex } from '@/api/home.js';

export default {
    name: "",
    components: {},
    props: ['intervalRefreshDate'],

    data() {
        return {
            timer: null,
            myData: []
        };
    },
    watch: {},
    computed: {},
    methods: {

        async init() {
            try {
                //综试区发展指数-中下
                const res = await lsdRegionEcommerceStatIndex({})
                let arr = res.data[0].children[0].children;
                let arr2 = [];
                arr.forEach(item => {
                    arr2.push({ name: item.districtName, value: item.totalEcommerceCount })
                })
                this.myData = arr2;
                await this.drawLine();
            } catch (err) {
                this.$message.error("数据加载失败")
            }
        },
        async drawLine() {
            // 基于刚刚准备好的 DOM 容器，初始化 EChart 实例
            let myChart = this.$echarts.init(document.getElementById('EcommerceEnterpriseRatio'))
            // 绘制图表
            let nameList = [], add = [], all = []
            // try {
            //     const res = await cmsSysCloudlsdCountEnterprise()
            //     res.data.forEach((item, index) => {
            //         const { enterpriseAddAmount, enterpriseAmount, city } = item
            //         //城市名
            //         nameList.push(city)
            //         //新增数据
            //         add.push(enterpriseAddAmount)
            //         //全部数据
            //         all.push(enterpriseAmount)

            //     });

            // } catch (err) {
            //     this.$message.error("数据加载失败")

            // }

            const img = require('@/assets/img/Group14.png')

            var myData = this.myData;

            var color = ['#F5B759', '#37A7F1', '#6CD499', '#557ED7'];

            // 计算总数
            var total = myData.reduce((sum, item) => sum + item.value, 0);
            var option = {
                // backgroundColor: '#0f1f47',
                color: color,
                title: {
                    show: false,
                    text: '企业总数',
                    left: '17%',

                    top: '35%',
                    textStyle: {
                        color: '#96A9BA',
                        fontSize: 14,
                        fontWeight: '100',
                    },
                },
                graphic: {
                    elements: [
                        // {
                        //     type: 'text',
                        //     left: '20.5%',
                        //     top: '50%',
                        //     style: {
                        //         text: total,
                        //         textAlign: 'center',
                        //         fill: '#fff',
                        //         fontSize: 22,
                        //         fontWeight: 'bold',
                        //     },
                        // },
                        // {
                        //     type: 'image',
                        //     // z: 3,
                        //     style: {
                        //         image: img,
                        //         width: 160,
                        //         // height: 1,
                        //     },
                        //     left: '6.6%',
                        //     top: '14%',
                        // },
                    ],
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a}<br/>{b}：{c} ({d}%)',
                },
                legend: {
                    orient: 'vertical',
                    right: '10%',
                    top: 'center',
                    icon: 'rect', // ✅ 正方形图标
                    itemWidth: 14,
                    itemHeight: 14,
                    itemGap: 16,
                    textStyle: {
                        color: '#96A9BA',
                        fontSize: 14,
                    },
                    selectedMode: 'multiple', // 点击可过滤
                    // ✅ 图例右边显示百分比
                    formatter: function (name) {
                        const item = myData.find((i) => i.name === name);
                        if (item) {
                            const percent = ((item.value / total) * 100).toFixed(1);
                            return `${name}  ${percent}%`;
                        }
                        return name;
                    },
                },
                series: [
                    {
                        name: '数据',
                        type: 'pie',
                        center: ['25%', '50%'],
                        radius: ['0%', '70%'],
                        data: myData,
                        label: {
                            show: false,
                        },
                        itemStyle: {
                            borderWidth: 5,
                            borderColor: '#0f1f47',
                        },
                        emphasis: {
                            scale: true,
                            itemStyle: {
                                shadowBlur: 25,
                                shadowColor: 'rgba(255, 255, 255, 0.3)',
                            },
                            label: {
                                show: true,
                                formatter: '{b}\n{d}%',
                                color: '#fff',
                                fontSize: 16,
                            },
                        },
                    },



                ],
            };





            myChart.clear();
            myChart.setOption(option);
        }
    },
    created() { },
    async mounted() {
        await this.init()

        // this.timer = setInterval(async () => {
        //     await this.drawLine();
        // }, this.intervalRefreshDate)


    },
    beforeDestroy() {
        console.log("销毁定时器")
        //2.销毁前清除定时器
        clearInterval(this.timer);
    },
}
</script>
<style lang="scss" scoped></style>